module.exports = __webpack_public_path__ + "static/colaboradores-04-54ce5f465258d2016af596ae8c915a48.png";